import React, { useEffect, useRef, useState } from 'react';
type AccordionProps = {
  id: string;
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  openClassName?: string;
  headerClassName?: string;
  panelClassName?: string;
};
export function Accordion({
  id,
  header,
  children,
  className = '',
  openClassName = '',
  headerClassName = '',
  panelClassName = ''
}: AccordionProps) {
  const [open, setOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement | null>(null);
  const [maxHeight, setMaxHeight] = useState('0px');
  useEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    setMaxHeight(open ? `${el.scrollHeight}px` : '0px');
  }, [open, children]);
  return <div className={`overflow-hidden rounded-xl border transition-colors duration-300 ${open ? `border-gold ${openClassName}` : 'border-gold/25'} ${className}`} data-id="element-20" data-mp="2s2sbixqcgekm">
      <button type="button" aria-expanded={open} aria-controls={`${id}-panel`} id={`${id}-header`} onClick={() => setOpen(v => !v)} className={`flex w-full items-center gap-3 px-4 py-4 text-left min-h-[56px] active:scale-[0.99] transition-transform ${headerClassName}`} data-id="element-21" data-mp="xp0xlm0zf8jd">
        <span className="flex-1" data-id="element-22" data-mp="3l3ghz6senjuu">{header}</span>
        <svg aria-hidden="true" viewBox="0 0 24 24" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-300 ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-23" data-mp="3q1rrfgesfscj">
          <path d="m6 9 6 6 6-6" data-id="element-24" data-mp="3mfdb2p9unxf" />
        </svg>
      </button>

      <div id={`${id}-panel`} role="region" aria-labelledby={`${id}-header`} ref={panelRef} className="accordion-panel" style={{
      maxHeight
    }} data-id="element-25" data-mp="7n95475u4mvl">
        <div className={`px-4 pb-5 pt-1 ${panelClassName}`} data-id="element-26" data-mp="clkg4l7v93fe">{children}</div>
      </div>
    </div>;
}